<template>
  <div class="counter">
    <h3 class="uppercase">{{ component.counterTitle }}</h3>
    <div class="grid grid-cols-1 gap-8 md:gap-10 md:grid-cols-2 lg:grid-cols-3 mt-10 lg:mt-20" v-if="component.counterCounters.length > 0" ref="countersRef">
      <div v-for="(counter, index) in component.counterCounters" :key="index">
        <CounterItem :item="counter" :index="index" :isVisible="isVisible" :sales-statistics="salesStatistics" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">  
  import { useElementVisibility } from '@vueuse/core';

  import type { GraphQLCounter } from '~/types/graphql';
  import type { SalesStatisticsQueryResult } from '~/types/api';
  import CounterItem from './CounterItem.vue';

  defineProps<{
    component: GraphQLCounter;
    index: number;
  }>();

  const { locale } = useI18n();

  const { data: salesStatistics } = await useAsyncData<SalesStatisticsQueryResult>(`sales-statistics-${locale.value}`, () =>
    $fetch('/api/vehicles/sales-statistics', {
      query: {
        locale: locale.value,
      },
    })
  );

  const countersRef = useTemplateRef<HTMLDivElement | null>('countersRef');

  const isVisible = useElementVisibility(countersRef, {
    rootMargin: '0px 0px -250px 0px',
  });
</script>

<style lang="scss" scoped></style>
